import api from '@/api'
import {
  CCOF_RESET_FORM,
  CREATE_CASE_SET_BACKEND_ERRORS,
  UCCO_SET_BACKEND_ERRORS,
  CASE_CREATION_ORDERS_RECEIVE_ORDER,
  CREATE_CASE_SET_PROGRESS,
  CCCO_FILL_MATERIALS_FORM,
  UCCO_INIT
} from '../mutations/available';

import _ from 'lodash'
import { getStringOrNull } from '../../helpers/strings'
import router from '../../router'

import {WrongParametersCode} from '../../dictionaries/api-error-codes'

const isValidPatientBirthday = (value) => {
  if (!value || typeof value !== 'string') {
    return false
  }

  const match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/)
  if (!match) {
    return false
  }

  const year = Number(match[1])
  const month = Number(match[2])
  const day = Number(match[3])
  const parsedDate = new Date(Date.UTC(year, month - 1, day))

  if (
    parsedDate.getUTCFullYear() !== year ||
    parsedDate.getUTCMonth() !== month - 1 ||
    parsedDate.getUTCDate() !== day
  ) {
    return false
  }

  const todayIsoDate = new Date().toISOString().substr(0, 10)
  return value >= '1900-01-01' && value <= todayIsoDate
}

export const createCase = async ({commit, state}, {vue, immediateValidation = false, immediateCreation = false}) => {

  let resultMaterials = {}
  for (let type in state.createCase.form.data.materials) {
    if (!state.createCase.form.data.materials.hasOwnProperty(type)) {
      continue
    }

    if (state.createCase.form.data.materials[type].length === 0) {
      continue
    }

    resultMaterials[type] = []

    for (let material of state.createCase.form.data.materials[type]) {
      const materialPayload = {
        code: material.code,
        description: material.description
      }
      if (type === 'tissues' && material.fragments != null) {
        materialPayload.fragments = Number(material.fragments)
      }
      resultMaterials[type].push(materialPayload)
    }
  }

  commit(CREATE_CASE_SET_BACKEND_ERRORS, {})

  const patientBirthday = state.createCase.form.data.patientBirthday
  if (!isValidPatientBirthday(patientBirthday)) {
    vue.$snotify.error(vue.$t('caseCreationOrderForm.fields.patientBirthday.errors.invalid'))
    return
  }

  commit(CREATE_CASE_SET_PROGRESS, {action: 'creation', value: true})

  let files = []

  for (let file of state.createCase.form.data.files) {
    if (!file.success) {
      continue
    }

    files.push({
      id: file.fileId,
      name: file.name
    })
  }

  try {
    await api.createCase({
      clientId: state.currentClientId,
      patientName: getStringOrNull(state.createCase.form.data.patientName),
      patientGender: state.createCase.form.data.patientGender,
      patientBirthday: state.createCase.form.data.patientBirthday,
      patientAddress: getStringOrNull(state.createCase.form.data.patientAddress),
      patientPhone: getStringOrNull(state.createCase.form.data.patientPhone),
      patientEmail: getStringOrNull(state.createCase.form.data.patientEmail),

      omi_policy_number: getStringOrNull(state.createCase.form.data.omi_policy_number),
      snils: getStringOrNull(state.createCase.form.data.snils),
      registration_place: getStringOrNull(state.createCase.form.data.registration_place),
      icd10: getStringOrNull(state.createCase.form.data.icd10),
      material_sampling: state.createCase.form.data.material_sampling,

      diagnosis: getStringOrNull(state.createCase.form.data.diagnosis),
      clientSpecialist: state.createCase.form.data.clientSpecialist,
      clinicalData: getStringOrNull(state.createCase.form.data.clinicalData),
      examination: getStringOrNull(state.createCase.form.data.examination),
      receiveMaterialMethod: (state.createCase.form.data.receiveMaterialMethod && state.createCase.form.data.receiveMaterialMethod.length)
        ? state.createCase.form.data.receiveMaterialMethod
        : null,
      services: state.createCase.form.data.services,
      externalId: getStringOrNull(state.createCase.form.data.externalId),
      externalLabel: getStringOrNull(state.createCase.form.data.externalLabel),
      files: files,
      materials: resultMaterials,
      immediateValidation: immediateValidation,
      immediateCreation: immediateCreation
    })
    commit(CCOF_RESET_FORM, 'createCase')
    vue.$snotify.success(vue.$t('caseCreationOrderForm.messages.successCreate'))
    vue.$refs['caseCreationOrderForm'].reset()
    router.push({name: 'caseCreationOrders'})
  } catch (e) {

    const caseCreationOrder = _.get(e, 'data.caseCreationOrder', null)

    //Если запрос на создание создался, но кейс в лабораторию не ушел по какой-то причине
    if (caseCreationOrder) {

      //Заполняем форму редактирования запроса
      commit(CASE_CREATION_ORDERS_RECEIVE_ORDER, caseCreationOrder)
      commit(UCCO_INIT, caseCreationOrder)

      //Переходим к редактированию запроса
      router.push({
        name: 'updateCaseCreationOrder',
        params: {
          id: caseCreationOrder.id
        }
      })

      //Очищаем форму создания
      commit(CCOF_RESET_FORM, 'createCase')
      vue.$refs['caseCreationOrderForm'].reset()

      //Заполняем ошибку
      setTimeout(function() {commit(UCCO_SET_BACKEND_ERRORS, e.body)}, 1)
    } else if (e.code && e.code === WrongParametersCode) {
      commit(CREATE_CASE_SET_BACKEND_ERRORS, e.body)
    } else {
      vue.$snotify.error(vue.$t('caseCreationOrderForm.messages.unableToCreate'))
    }
    console.log(e)
  }

  commit(CREATE_CASE_SET_PROGRESS, {action: 'creation', value: false})
}

export const cccoFillMaterialsForm = async ({commit}, materialsForm) => {
  commit(CCCO_FILL_MATERIALS_FORM, materialsForm)
}
